import React from "react";
import NosotrosIMG from "./img/nosotros2.jpg";
import { Typography } from "@mui/material";
import "./about.css";

function About() {
  return (
    <>
      {/* Hero image */}
      <div className="img-container">
        <img src={NosotrosIMG} alt="iglesia-la-fe" />
        <Typography variant="h1" className="img-title">
          Nosotros
        </Typography>
      </div>

      {/* About Us section */}
      <section className="page-section about-section">
        <div className="container">
          <div className="content-wrapper">
            <div className="about-us-card">
              <Typography variant="h2" className="section-title">
                QUIENES SOMOS
              </Typography>
              <Typography variant="body1" className="section-text">
                Somos una Iglesia Evangélica pentecostal, parte de la gran familia de las Asambleas de Dios de Panamá, 
                e Iglesia Fraterna del Ministerio Templo la Felicidad. Creemos en la Biblia como nuestra máxima norma 
                de fe y conducta, en la salvación por gracia, solo por la fe, y en las doctrinas fundamentales de la 
                fe cristiana Evangélica.
              </Typography>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision section */}
      <section className="page-section mission-vision-section">
        <div className="container">
          <div className="content-wrapper">
            <div className="cards-container">
              {/* Mission */}
              <div style={{display: "flex", flexDirection: "column", gap: "2rem"}}>
              <div className="card mission-card">
                <h2>Misión</h2>
                <p>
                  Nuestra Misión es predicar el evangelio de Jesucristo, hacer discípulos, 
                  capacitar a los creyentes para la obra del ministerio, ser una familia de 
                  fe y testimonio, una iglesia de discípulos, que hacen discípulos.
                </p>
              </div>

              {/* Vision */}
              <div className="card vision-card">
                <h2>Visión</h2>
                <p>
                  Ser una iglesia vibrante y transformadora que impacte a San Miguelito y más allá,
                  llevando a las personas a un encuentro personal con Cristo, siendo un faro de luz 
                  que refleje los valores del Reino de Dios en cada ámbito de la sociedad...
                </p>
              </div>
              </div>
            </div>
          
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
